// PWA-aware token storage configuration
export const PWA_TOKEN_CONFIG = {
  // For PWA users, we can be more permissive with token storage
  USE_EXTENDED_STORAGE: true,
  // Store refresh tokens for longer periods in PWAs
  REFRESH_TOKEN_EXTENDED_EXPIRY: 30 * 24 * 60 * 60 * 1000, // 30 days in milliseconds
  REFRESH_BEFORE_EXPIRY_MINUTES: 30, // 30 minutes before expiration
}

// Detect if app is running as PWA
export const isPWA = (): boolean => {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    'standalone' in window.navigator ||
    document.referrer.includes('android-app://')
  )
}
